import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import 'rxjs';

import { AlertService } from '../../../providers/alert-service';
import { ContratoService } from '../../../providers/contrato-service';
import { FileService } from '../../../providers/file-service';

@Component({
  selector: 'page-modal-termo-referencia-aditivo',
  templateUrl: 'modal-termo-referencia-aditivo.html'
})
export class ModalTermoReferenciaAditivoPage {

  contrato: any = null;
  listaArquivosAditivo: any = [];
  listaArquivosContrato: any = [];
  listaArquivosContratoTermo: any = [];
  listaAditivos: any = [];
  titulo: any;
  isJurisdicionado: any;
  servico: any;
  tiposAceitos: any = "application/pdf";
  loading: boolean = true;
  cdModulo: any;

  itemAditivo: any = {
    idArquivoVinculado: '',
    idModuloAnalise: 0,
    nmArquivo: '',
    idPca: '',
    descTipo: '',
    idTipo: '',
    idArquivoAditivo: ''
  }


  constructor(private alertService: AlertService,
    private viewCtrl: ViewController,
    private fileService: FileService,
    public navParams: NavParams,
    public contratoService: ContratoService) {
    this.titulo = this.navParams.get('titulo');
    this.contrato = this.navParams.get('contrato');
    this.isJurisdicionado = this.navParams.get('isJurisdicionado');
    this.cdModulo = 5;
    this.carregarModal();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  carregarModal() {
    this.listarArquivosContrato(this.contrato);
    this.listarArquivosContratoTermo(this.contrato);

    this.loading = false;
  }

  listarArquivosContrato(contrato) {
    this.fileService.listarArquivo(contrato.id, this.cdModulo, "5").subscribe(data => {
      this.listaArquivosContrato = data;
      //this.loading = false;
    }, error => {
      console.log("erro: " + error);
      this.loading = false;
      this.alertService.mostraAlerta("", "Não foi possível listar os arquivos.");
    });
  }

  listarArquivosContratoTermo(contrato) {
    this.fileService.listarArquivo(contrato.id, this.cdModulo, "24").subscribe(data => {
      this.listaArquivosContratoTermo = data;
      //this.loading = false;
    }, error => {
      console.log("erro: " + error);
      this.loading = false;
      this.alertService.mostraAlerta("", "Não foi possível listar os arquivos.");
    });
  }



  fileChangeContrato(event, cdArquivo) {
    this.alertService.mostraModalConfirmacao("Salvar Arquivo", "Arquivo selecionado, confirma importação?", callback => {
      if (callback) {
        let fileList: FileList = event.target.files;
        if (fileList.length > 0) {
          let file: File = fileList[0];

          if (file.size <= 10485760) {
            this.loading = true;
            this.fileService.enviarArquivo(event, this.contrato.id, this.cdModulo, cdArquivo).subscribe(data => {
              this.alertService.mostraAlerta("", "Arquivo importado com sucesso!");
              this.carregarModal();
            }, error => {
              this.alertService.mostraAlerta("Houve um erro ao carregar arquivo.", error);
              console.log("erro: " + error);
            });
          } else {
            this.alertService.mostraAlerta("", "Arquivo ultrapassou o limite de tamanho de 10Mb.");
          }
        }

        this.loading = false;

      }
    });
  }


  baixarArquivo(idArquivoVinculado) {
    this.loading = true;
    this.fileService.downloadArquivo(idArquivoVinculado);
    this.loading = false;
  }

  deletarArquivo(arquivo) {
    this.alertService.mostraModalConfirmacao("Excluir Arquivo", "Você tem certeza que deseja excluir o arquivo " + arquivo.nmArquivo + "?",
      retornoModal => {
        if (retornoModal) {
          this.loading = true;
          this.fileService.deletarArquivo(arquivo.idArquivoVinculado).subscribe(data => {
            this.alertService.mostraAlerta("", "Arquivo excluído com sucesso.");
            this.carregarModal();
          }, error => {
            console.log("erro: " + error);
            this.alertService.mostraAlerta("", "Houve um erro ao excluir arquivo.");
          });

          this.loading = false;
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-termo-referencia-aditivo/modal-termo-referencia-aditivo.ts